import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isBusy: true,
};

const busySlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setBusy: (state, action) => {
      state.isBusy = action.payload;
    },
  },
});

export const { setBusy } = busySlice.actions;
export default busySlice.reducer;
